import styled from 'styled-components';

import { Color } from '../../../../shared/constants/Colors';
import { MediaQuery } from '../../../../shared/constants/Styles';
import { Typography } from '../../../../shared/constants/Typographies';

export const PostFooter = styled.div`
  padding-top: 45px;
  display: flex;
  ${MediaQuery.S_AND_DOWN} {
    flex-direction: column;
    align-items: center;
  }
`;

export const AuthorSection = styled.div`
  flex-grow: 2;

  ${MediaQuery.M_AND_DOWN} {
    margin-left: 20px;
  }

  ${MediaQuery.S_AND_DOWN} {
    margin-left: 0px;
    > * {
      &:first-child {
        text-align: center;
      }
    }
  }
`;

export const Label = styled.p`
  ${Typography.S_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin-bottom: 10px;
`;

export const AuthorContent = styled.div`
  display: flex;
  padding-top: 15px;

  ${MediaQuery.S_AND_DOWN} {
    flex-direction: column;
    align-items: center;
  }
`;

export const AuthorDescription = styled.div`
  max-width: 280px;
  padding: 15px;

  ${MediaQuery.S_AND_DOWN} {
    > * {
      &:first-child {
        text-align: center;
      }
    }
  }
`;

export const TagSection = styled.div`
  width: 200px;
  flex-grow: 1;
  position: relative;

  ${MediaQuery.S_AND_DOWN} {
    margin-top: 20px;
    width: auto;
    > * {
      &:first-child {
        text-align: center;
      }
    }
  }
`;

export const Tags = styled.div`
  padding-top: 15px;
  position: relative;

  a {
    display: -webkit-inline-box;
    margin: 0 5px 5px 0;
  }
`;
